import { Component, computed, inject, input } from '@angular/core';
import { AlertService } from '../../../services/alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
  standalone: false,
})
export class AlertComponent {
  protected readonly alertService = inject(AlertService);

  adminArea = input<boolean>(false);

  snackbarClass = computed(() => {
    switch (this.alertService.alert()?.type) {
      case 'error':
        return 'snackbar-red';
      case 'success':
        return 'snackbar-green';
      case 'info':
        return 'snackbar-yellow';
      default:
        return 'snackbar-blue';
    }
  });

  public closeAlert(): void {
    this.alertService.hideAlert();
  }
}
